






















































import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";
import { useUserPlanStore } from "@/employee/store/userPlan";
import { PlanType, UserCoverageLevel, UserCoverageLevels } from "@/shared/types";
import _ from "lodash";

@Component
export default class EditCoverageLevel extends Vue {
  themeStore = useThemeStore();
  userPlanStore = useUserPlanStore();
  isSubmitting = false;
  coverageLevels: UserCoverageLevel[] = [];
  PlanType = PlanType;

  @Prop({ required: true })
  onSave: () => void;

  @Prop({ required: true })
  toggleClose: () => void;

  @Prop({ required: true })
  show: { value: boolean };

  @Watch("userPlanStore.userCoverageLevels")
  onUserCoverageLevelsChanged () {
    this.cloneStoreToModel();
  }

  @Watch("show.value")
  onShowChanged () {
    if (this.show.value === true) {
      this.cloneStoreToModel();
    }
  }

  cloneStoreToModel () {
    this.coverageLevels = _.cloneDeep(this.userPlanStore.userCoverageLevels);
  }

  mounted () {
    this.userPlanStore.getUserCoverageLevels();
  }

  save () {
    this.isSubmitting = true;

    const request: UserCoverageLevels = {
      coverageLevels: this.coverageLevels
    };

    this.userPlanStore.updateUserCoverageLevels(request)
      .then(() => this.onSave())
      .catch(() => {/*noop*/})
      .finally(() => {
        this.isSubmitting = false;
      });
  }
}
